module.exports = __webpack_public_path__ + "images/file_icons_v2/apk-39c55e2b34baca88338b25ad8de57ced.svg";